<template>
  <div class="StoreWallateRecharge">
    <div class="StoreWallateRechargeTitle">
      <el-page-header @back="goBack" content=""> </el-page-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'moneyManage' }"
          ><span class="titleText">财务管理</span></el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ name: 'storeWallateRecharge' }"
          ><span class="titleText">店铺余额充值</span></el-breadcrumb-item
        >
      
      </el-breadcrumb>
    </div>

    <div v-loading="btnLoading" class="mainBox">
      <div class="mainBoxForm">
        <el-form
          ref="form"
          size="mini"
          :model="storeRechargeForm"
          label-width="120px"
        >
          <el-form-item label="充值店铺：">
            <div class="s_name skyblue">
              {{ companyInfo.s_name }}
            </div>
          </el-form-item>
          <el-form-item label="充值金额：">
            <el-input class="inputMoney" v-model="storeRechargeForm.money">
              <el-button slot="append">元</el-button>
            </el-input>
          </el-form-item>

          <el-form-item label="推荐金额：">
            <div class="moneyRecomendBox">
              <div
                @click="() => startStoreRechargeMoney(item)"
                v-for="(item, index) in itemData"
                :key="index"
                class="moneyItem"
              >
                <span>{{ item.label }}元</span>
                <span>¥{{ item.value }}</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="()=>startStoreRechargeMoney()" type="info"
              >充值</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { addRecharge } from "@/api/api";
export default {
  name: "StoreWallateRecharge",
  data() {
    return {
      btnLoading: false,
      formInfo2: {
        visible: false,
        info: "",
      },
      storeRechargeForm: {
        money: "",
      },
      itemData: [
        {
          label: "3千",
          value: 3000,
        },
        {
          label: "5千",
          value: 5000,
        },
        {
          label: "1万",
          value: 10000,
        },
        {
          label: "2万",
          value: 20000,
        },
        {
          label: "3万",
          value: 30000,
        },
        {
          label: "5万",
          value: 50000,
        },
      ],
    };
  },
  computed: {
    ...mapState(["userInfo", "companyInfo"]),
  },
  methods: {
    goBack() {
      this.$router.replace("moneyManage");
    },
    formateTotalMoney(item) {
      if (item.fm_status == 1) {
        return item.prepayment;
      }
      if (item.fm_status == 2) {
        return (item.totalMoney - item.prepayment).toFixed(2);
      } else {
        return item.totalMoney;
      }
    },
    ensureRechargeMoney() {
      this.btnLoading = true;
      let data = {
        access_token: this.userInfo.access_token,
        money: this.storeRechargeForm.money,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }

      this.$axios({ method: "post", data: param, url: addRecharge })
        .then((res) => {
          if (res.data.resultCode == 1) {
            // id=5257e62dc3e6406e8003d72d95ae1442&order_id=10006040&totalMoney=1&prepayment=0&type=6&fm_status=3&pay_flag=0&store_name=18866550002三十度佳测试&store_id=10000002956171705580
            console.log("res.data.data", res.data.data);
              this.storeRechargeForm.money = 0
            let totalMoney = this.formateTotalMoney(res.data.data);
            let {
              id,
              order_id,
              prepayment,
              type,
              fm_status,
              pay_flag,
              store_name,
              store_id,
            } = res.data.data;
            setTimeout(() => {
              this.btnLoading = false;
            
              this.$router.push({
                name: "payPage",
                query: {
                  id,
                  order_id,
                  totalMoney,
                  prepayment,
                  type,
                  fm_status,
                  pay_flag,
                  store_name,
                  store_id,
                },
              });
            }, 2000);
          } else {
            this.btnLoading = false;
            this.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.btnLoading = false;
          this.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    startStoreRechargeMoney(item) {
      if (!item) {
        if (isNaN(this.storeRechargeForm.money)) {
          this.$alert("请输入有效的金额");
          return;
        }


        if (this.storeRechargeForm.money <= 0) {
          this.$alert("请输入有效的金额");
          return;
        }
      } else {
        this.storeRechargeForm.money = item.value;
      }
      this.$nextTick(() => {
        this.$confirm(
          `确认向${this.companyInfo.s_name}余额账户充值${this.storeRechargeForm.money}元？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            // type: "warning"
          }
        )
          .then(this.ensureRechargeMoney)
          .catch(() => {});
      });
    },
  },
};
</script>

<style scoped lang='less'>
.StoreWallateRecharge {
  padding: 10px;
}
.titleText {
  font-size: 13px;
  color: #009e96 !important;
}
.StoreWallateRechargeTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.formInfo {
  width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 13px;
  color: #009688;
  border-radius: 2px;
  margin-bottom: 10px;
  height: 20px;
}
.mainBoxForm {
}
.inputMoney {
  width: 200px;
}
.mainBox {
  margin-top: 30px;
  padding-bottom: 30px;
}
.s_name {
  font-size: 13px;
}
.moneyItem {
  background-color: #fff;
  border: 1px solid #009688;
  width: 80px;
  height: 50px;
  border-radius: 5px;
  text-align: center;
  color: #009688;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 20px;
  margin: 10px 0;
}
.moneyRecomendBox {
  display: flex;
  justify-content: space-between;
  // background-color: red;
  flex-wrap: wrap;
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/StoreWallateRecharge.vue